import './button.css';

export interface ButtonProps {
  label: string;
  onPress?: () => void;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  disabled?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  children?: React.ReactNode;
}

export const Button = ({
  label,
  onPress,
  onClick,
  variant = 'primary',
  disabled = false,
  className = '',
  type = 'button',
  children,
}: ButtonProps) => {
  const handleClick = onClick || onPress;

  return (
    <button
      type={type}
      className={`btn btn-${variant} ${className}`}
      onClick={handleClick}
      disabled={disabled}
    >
      {children || label}
    </button>
  );
};
